import * as React from "react";
import Box from "@mui/material/Box";
import WindPlot from "../wind";
import WeatherPlot from "../weather";
import { a11yProps, CustomTabPanel, getStationData } from "../util";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


export default function Comersee ({ forecast }) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let [vmax_col, speed_col, dir_col, t2m_col, precip_col, dursun_col, twater_col, qff_col] = getStationData(forecast, "COL", "como", "QFF_KLO_LUG");
  let [vmax_cre, speed_cre, dir_cre, t2m_cre, precip_cre, dursun_cre, twater_cre, qff_cre] = getStationData(forecast, "CRE", "como", "QFF_KLO_LUG");
  let [vmax_sor, speed_sor, dir_sor, t2m_sor, precip_sor, dursun_sor, twater_sor, qff_sor] = getStationData(forecast, "GER", "como", "QFF_KLO_LUG");

  return (
    <div>
      <title>Comersee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Comersee</h2>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs" variant="fullWidth">
                <Tab label="Colica" {...a11yProps(0)} />
                <Tab label="Cremia" {...a11yProps(1)} />
                <Tab label="Gera Lario" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_col} speed={speed_col} dir={dir_col} />
                <WeatherPlot t2m={t2m_col} precip={precip_col} sun={dursun_col} twater={twater_col} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_cre} speed={speed_cre} dir={dir_cre} />
                <WeatherPlot t2m={t2m_cre} precip={precip_cre} sun={dursun_cre} twater={twater_cre} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_sor} speed={speed_sor} dir={dir_sor} />
                <WeatherPlot t2m={t2m_sor} precip={precip_sor} sun={dursun_sor} twater={twater_sor} />
              </Box>
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </div>
  );
};
